import "select2";
import SimpleBar from "simplebar";

$(".js-select2").each(function () {
  if ($(this)[0].id === "cource2") {
    $(this).select2({
      dropdownParent: $(this).parents(".js-select2-container"),
      scrollAfterSelect: true,
      placeholder: "Название курса",
    });
  } else {
    $(this).select2({
      dropdownParent: $(this).parents(".js-select2-container"),
    });
  }

  $(this).on("select2:open", () => {
    const optionsContainer = $(".select2-results__options").get(0);

    setTimeout(() => {
      new SimpleBar(optionsContainer, { autoHide: false });
    }, 0);
  });
});

/* ---------------MULTISELECT------------------------ */
$(".js-select2-multiple").each(function () {
  let dropdown;
  const applyButton =
    '<button class="button"><span class="button__text">Применить</span></button>';
  const select = this;
  let selections;
  let selectionsIds;
  const optionAllElement = $(select).find("option[value='all']");

  const input = $(this)
    .parent(".js-select2-container")
    .find(".js-select-input");
  const handleInputFocus = function () {
    $(this).hide();
    $(select).select2("open");
  };

  const handleApplyClick = function () {
    setTimeout(() => {
      $(select).select2("close");
    }, 0);
  };

  $(input).on("focus", handleInputFocus);

  $(this).select2({
    dropdownParent: $(this).parents(".js-select2-container"),
    closeOnSelect: false,
    allowClear: true,
    placeholder: "",
    placeholderOption: "first",
  });

  const handleOpen = function () {
    const container = $(".select2-results__options").get(0);
    initSimpleBar(container);

    selections = $(select).select2("data");
    selectionsIds = selections.map((e) => e.id);

    dropdown = $(".select2-dropdown");
    if (dropdown) {
      $(dropdown).append($(applyButton));
    }

    dropdown.find(".button").on("click", handleApplyClick);
  };

  const handleClose = function () {
    selections = $(select).select2("data");
    selectionsIds = selections.map((e) => e.id);

    if (selections.length) {
      $(input).attr("placeholder", `Выбранные темы (${selectionsIds.length})`);
    } else {
      $(input).attr("placeholder", "Все темы");
    }

    if (dropdown) {
      $(dropdown).find(".button").remove();
    }

    $(input).show();
  };

  const handleSelect = function () {
    selections = $(select).select2("data");
    selectionsIds = selections.map((e) => e.id);
  };

  const handleUnselect = function (event) {
    selections = $(select).select2("data");

    if (!event.params.originalEvent) {
      return;
    }

    event.params.originalEvent.stopPropagation();
  };

  const handleClearing = function () {
    setTimeout(() => {
      $(select).select2("open");
      $(input).hide();
    }, 0);
  };

  $(this).on("select2:open", handleOpen);
  $(this).on("select2:close", handleClose);
  $(this).on("select2:select", handleSelect);
  $(this).on("select2:unselect", handleUnselect);
  $(this).on("select2:clearing", handleClearing);
});

function initSimpleBar(container) {
  setTimeout(() => {
    new SimpleBar(container, { autoHide: false });
  }, 0);
}

const resetBtn = $(".js-resetFilter");

// Проверка селектов
// function checkSelects() {
//   let hasActive = false;

//   $(".js-select2").each(function () {
//     const val = $(this).val();

//     if (val && val !== "" && val.length !== 0 && val !== "default") {
//       hasActive = true;
//     }
//   });

//   resetBtn.prop("disabled", !hasActive);
// }

// $(".js-select2").on("change", () => {
//   checkSelects();
// });

//  Сброс
// resetBtn.on("click", () => {
//   $(".js-select2").each(function () {
//     $(this).val("").trigger("change");
//   });

//   resetBtn.prop("disabled", true);
// });
